import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomLandingFactory {
  custom:any = null;
  constructor(private route: ActivatedRoute) { }
  setCustom(custom: any){
    this.custom = custom;
  }
  getCustom():any{
    return this.custom;
  }
  isLanding(){
    // let isLandingPage = this.custom !==null?true:this.route.snapshot.data['isLanding'] || this.route.snapshot.firstChild?.data['isLanding'];
    let isLandingPage = this.custom !==null?true:location.pathname.indexOf('public/') !== -1 || location.pathname.indexOf('shared/') !== -1 || location.pathname.indexOf('contact-login') !== -1 || location.pathname.indexOf('preview-customization') !== -1;
    return isLandingPage;
  }
}
